import React from 'react'
import Autocomplete from '../../../components/Autocomplete'
import { cenarioRepository } from '../CenarioRepository'
import { autocompleteHelpers } from 'elentari'
const { toOption } = autocompleteHelpers

export const loadCenario = async inputValue => {
  const response = await cenarioRepository.list({
    query: {
      descricao: inputValue,
      order: 'descricao asc'
    },
    paginate: {
      limit: 10
    }
  })
  if (response.ok) {
    return response.data.map(toOption('descricao'))
  }
  return []
}

const CenarioAutocomplete = props => {
  return (
    <Autocomplete
      repository={cenarioRepository}
      labelOption="descricao"
      loadOptions={inputValue => loadCenario(inputValue)}
      {...props}
    />
  )
}

export { CenarioAutocomplete }
